"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BarLabelPlot = BarLabelPlot;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var React = _interopRequireWildcard(require("react"));
var _BarLabelItem = require("./BarLabelItem");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = ["bars", "skipAnimation"];
/**
 * @ignore - internal component.
 */
function BarLabelPlot(props) {
  const {
      bars,
      skipAnimation
    } = props,
    other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(React.Fragment, {
    children: bars.map(({
      xOrigin,
      yOrigin,
      x,
      y,
      seriesId,
      dataIndex,
      color,
      value,
      width,
      height,
      layout
    }) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_BarLabelItem.BarLabelItem, (0, _extends2.default)({
      seriesId: seriesId,
      dataIndex: dataIndex,
      value: value,
      color: color,
      xOrigin: xOrigin,
      yOrigin: yOrigin,
      x: x,
      y: y,
      width: width,
      height: height,
      skipAnimation: skipAnimation ?? false,
      layout: layout ?? 'vertical'
    }, other), `${seriesId}-${dataIndex}`))
  });
}